import styled from 'styled-components/native';

import ArtistProfileHeader from 'components/ArtistProfileHeader';
import { ArtistProfileHeaderProps } from 'components/ArtistProfileHeader/ArtistProfileHeader';

export default styled(ArtistProfileHeader)<ArtistProfileHeaderProps>``;
